// extracted by mini-css-extract-plugin
export default {"status":"tPkKUZQT9cxVcO7YS8O1aA=="};